// extracted by mini-css-extract-plugin
export default {"container":"contacts_container__vtIn-","list":"contacts_list__YLNwi","list__noUpper":"contacts_list__noUpper__+5iPp","link":"contacts_link__lgihD","map":"contacts_map__1UE-p"};